import {
  REFERRAL_GET_PENDING,
  REFERRAL_GET_ACTIVE,
  REFERRAL_REQUEST,
  REFERRAL_SUCCESS,
  REFERRAL_ERROR
} from "@/store/types"

import axios from "@/store/axios"

const state = {
  actives: null,
  activeTotalCount: 0,
  activeCurrentPage: 1,
  activeCurrentFilter: "",
  pendings: null,
  pendingTotalCount: 0,
  pendingCurrentPage: 1,
  isLoading: false,
  error: null
}

const getters = {
  getPendingReferrals: (state) => state.pendings,
  getPendingReferralCurrentPage: (state) => state.pendingCurrentPage,
  getPendingReferralTotalCount: (state) => state.pendingTotalCount,
  getActiveReferrals: (state) => state.actives,
  getActiveReferralCurrentPage: (state) => state.activeCurrentPage,
  getActiveReferralTotalCount: (state) => state.activeTotalCount,
  getActiveReferralCurrentFilter: (state) => state.activeCurrentFilter,
  isReferralLoading: (state) => state.isLoading,
  getReferralError: (state) => state.error
}

const actions = {
  //filter
  [REFERRAL_GET_PENDING]: ({ commit }, { page = 1 } = {}) => {
    return new Promise((resolve, reject) => {
      commit(REFERRAL_REQUEST)

      axios
        .get(`/api/v3/referral_invites/?page=${page}`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          resp.data.page = page
          commit(REFERRAL_SUCCESS, { pending: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(REFERRAL_ERROR, err)
          reject(err)
        })
    })
  },
  [REFERRAL_GET_ACTIVE]: ({ commit }, { page = 1, filter = "" } = {}) => {
    return new Promise((resolve, reject) => {
      commit(REFERRAL_REQUEST)

      axios
        .get(
          `/api/v3/referrers/referrals/?page=${page}${
            filter ? "&" + filter + "=true" : ""
          }`
        )
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          resp.data.page = page
          resp.data.filter = filter
          commit(REFERRAL_SUCCESS, { active: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(REFERRAL_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [REFERRAL_REQUEST]: (state) => {
    state.isLoading = true
  },
  [REFERRAL_SUCCESS]: (state, { pending, active }) => {
    // setTimeout(() => {
    state.isLoading = false
    if (pending) {
      state.pendings = pending.results
      state.pendingCurrentPage = pending.page
      state.pendingTotalCount = pending.count
    }

    if (active) {
      state.actives = active.results
      state.activeCurrentPage = active.page
      state.activeTotalCount = active.count
      state.activeCurrentFilter = active.filter
    }
    // }, 3000)
  },
  [REFERRAL_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err.message
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
